import React from "react"
import PartProgress from "./PartProgress"

const splitCourses = false
const CourseProgress = ({
  data,
  appliesForStudyRight,
  currentCourseVariant,
}) => {
  // "part"-prefixed groups are quiz points, which are not shown on this course
  const programmingExercises = Object.entries(data).filter(
    ([name]) => !name.startsWith("part"),
  )

  const correctOrder = [
    "Intro",
    "RDD",
    "dataframe",
    "Mllib",
    "Graphframes",
    "StructuredStreaming",
    "Extra",
  ]

  programmingExercises.sort((x, y) => {
    if (correctOrder.indexOf(x[0]) < correctOrder.indexOf(y[0])) {
      return -1
    } else if (correctOrder.indexOf(x[0]) > correctOrder.indexOf(y[0])) {
      return 1
    }
    return 0
  })

  const programmingExercisesWithoutExtra = programmingExercises.filter(
    ([name, data]) => name !== "Extra",
  )

  const extraExercises = programmingExercises.filter(
    ([name, data]) => name === "Extra",
  )

  extraExercises[0][0] = "Exercises"

  let programmingExercisesNPoints = 0
  let programmingExercisesMaxPoints = 0
  programmingExercisesWithoutExtra.forEach(([name, data]) => {
    programmingExercisesNPoints += data.Points.n_points
    programmingExercisesMaxPoints += data.Points.max_points
  })

  let programmingExerciseProgress = 0
  if (programmingExercisesMaxPoints !== 0) {
    programmingExerciseProgress =
      Math.floor(
        (programmingExercisesNPoints / programmingExercisesMaxPoints) * 100,
      ) / 100
  }

  const total = [
    [
      "Exercises",
      {
        Points: {
          group: "total",
          max_points: programmingExercisesMaxPoints,
          n_points: programmingExercisesNPoints,
          progress: programmingExerciseProgress,
        },
      },
    ],
  ]

  return (
    <div>
      <h4>Exercises</h4>
      {programmingExercisesWithoutExtra.map(([name, data]) => (
        <PartProgress name={name} data={data} />
      ))}
      <h4>Total</h4>
      {total.map(([name, data]) => (
        <PartProgress name={name} data={data} />
      ))}
      <h4>Extra</h4>
      {extraExercises.map(([name, data]) => (
        <PartProgress name={name} data={data} />
      ))}
    </div>
  )
}

export default CourseProgress
